import { ItemCard } from '../../components/ItemCard';
import type { SpaItemCardProps } from './SpaItemCard.types';

const defaultFormatGuests = (count: number) => `${count} ${count === 1 ? 'guest' : 'guests'}`;

function buildMeta(
  duration: string | undefined,
  numberOfGuests: number | undefined,
  formatGuests: (count: number) => string
): string {
  const meta: string[] = [];
  if (duration) meta.push(duration);
  if (numberOfGuests && numberOfGuests > 0) {
    meta.push(formatGuests(numberOfGuests));
  }
  return meta.join(' \u00B7 ');
}

export function SpaItemCard({
  id,
  name,
  imageUrl,
  price,
  discount,
  duration,
  numberOfGuests,
  unavailable,
  promotionName,
  fromPriceLabel = 'From',
  soldOutLabel = 'Sold out',
  noImageLabel = 'No image',
  formatGuests = defaultFormatGuests,
  onSelect,
}: SpaItemCardProps) {
  const meta = buildMeta(duration, numberOfGuests, formatGuests);

  return (
    <ItemCard
      image={{ src: imageUrl, alt: name, placeholderLabel: noImageLabel }}
      title={name}
      meta={meta || undefined}
      statusBadge={unavailable ? soldOutLabel : undefined}
      imageBadge={promotionName || undefined}
      price={
        !unavailable && price
          ? {
              amount: price.amount,
              currencyCode: price.currencyCode,
              label: fromPriceLabel,
              discount,
            }
          : undefined
      }
      unavailable={unavailable}
      ariaLabel={name}
      onSelect={() => onSelect(id)}
    />
  );
}
